export const logoNegative = ['608 134', `
  <title>RideDoc Logo</title>
  <g>
    
  </g>
`]
